<template>
  <el-checkbox-group style="display: inline-block" v-model="myValue">
    <el-checkbox
      v-for="opt in colorList"
      :key="opt.text"
      :label="opt.code"
      :disable="disable"
    >
      {{ opt.text }}
      <span
        v-if="icon === ''"
        style="
          display: inline-block;
          height: 14px;
          width: 14px;
          border-radius: 2px;
          margin-left: 2px;
          font-size: 14px;
        "
        :style="{ 'background-color': opt.color }"
      ></span>
      <em
        v-else
        :class="icon"
        :style="{ color: opt.color }"
        style="font-size: 16px"
      ></em>
    </el-checkbox>
  </el-checkbox-group>
</template>

<script>
export default {
  props: {
    colorList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    icon: {
      type: String,
      default: "",
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    myValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("select", val);
      },
    },
  },
};
</script>
